import { CSSProperties, ReactNode } from 'react';

import './dashboard.css';

export type DashboardCardSize = '4x2' | '3x2' | '3x1.5' | '3x1' | '2x3' | '2x2' | '2x1.5' | '2x1' | '2x0.5';

export interface DashboardProps {
    children?: ReactNode;
    className?: string;
}

export interface DashboardCardProps {
    size: DashboardCardSize;
    children: ReactNode;
    className?: string;
}

const CARD_SPANS: Record<DashboardCardSize, { cols: number; rows: number }> = {
    '4x2': { cols: 4, rows: 4 },
    '3x2': { cols: 3, rows: 4 },
    '3x1.5': { cols: 3, rows: 3 },
    '3x1': { cols: 3, rows: 2 },
    '2x3': { cols: 2, rows: 6 },
    '2x2': { cols: 2, rows: 4 },
    '2x1.5': { cols: 2, rows: 3 },
    '2x1': { cols: 2, rows: 2 },
    '2x0.5': { cols: 2, rows: 1 }
};

export const Dashboard = ({ children, className }: DashboardProps) => (
    <div className={`dashboard-grid ${className ?? ''}`}>
        <div className='dashboard-grid-cells'>{children}</div>
    </div>
);

export const DashboardCard = ({ size, children, className }: DashboardCardProps) => {
    const span = CARD_SPANS[size];

    return (
        <div
            className={`dashboard-card ${className ?? ''}`}
            style={
                {
                    '--dashboard-card-cols': String(span.cols),
                    '--dashboard-card-rows': String(span.rows)
                } as CSSProperties
            }>
            {children}
        </div>
    );
};
